<template>
    <div>
        <div>
            <h3>Reports</h3>
            <hr>
            <br>
            Date Range: <input v-model="startDate" @keyup.enter="doSearch" type="date"/>&nbsp;<input v-model="endDate" @keyup.enter="doSearch" type="date"/>
            <br/>
            <br/>
            VIN Number <input v-model="vin" @keyup.enter="doSearch" type="text"/>
            <br/>
            <br/>
            <button v-on:click="doSearch">Submit Search</button>
        </div>
    </div>
</template>
<script>
    import swal from 'sweetalert2'
    import axios from 'axios'
    export default {
      name: 'reportsPage',
      data () {
        return {
          startDate: '',
          endDate: '',
          vin: ''
        }
      },
      methods: {
        doSearch: function () {
          if (this.startDate === '' && this.endDate === '' && this.vin === '') {
            swal('Warning', 'You must have at least one field', 'warning')
            return
          }
          axios.post('./static/api/Ajax.php', {
            startDate: this.startDate,
            endDate: this.endDate,
            vin: this.vin,
            action: 'Get Report'
          }).then((response) => {
            if (response.data.status === 'success') {
              this.$store.commit('reportResults', response.data.data)
              window.location = './#/reportsResults'
            } else if (response.data.status) {
              swal('Warning','No results found!','warning')
            }
          }).catch((e) => {
            console.log(e)
          })
        }
      },
      mounted () {
        if (this.$store.getters.getUserStatus !== 'Admin') {
          window.location = './#/search'
        }
      }
    }
</script>
<style scoped>

</style>     


// WEBPACK FOOTER //
// src/components/reportsPage.vue